'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStateFromCookies = undefined;

var _reduxCookiesMiddleware = require('./reduxCookiesMiddleware');

var _reduxCookiesMiddleware2 = _interopRequireDefault(_reduxCookiesMiddleware);

var _getStateFromCookies = require('./getStateFromCookies');

var _getStateFromCookies2 = _interopRequireDefault(_getStateFromCookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.getStateFromCookies = _getStateFromCookies2.default;
exports.default = _reduxCookiesMiddleware2.default;
//# sourceMappingURL=index.js.map